import { template } from "@ember/template-compiler";
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { modifier } from 'ember-modifier';
import type OpenIdConnectService from 'parog-web/services/open-id-connect';
import type SemeiaSessionService from 'parog-web/services/session';
import emberSwal from 'ui-kit/utils/ember-swal';
interface Signature {
    Args: {
        authorizationCode: string | undefined;
        openIdConnectService: OpenIdConnectService;
    };
}
export default class OpenIdConnectLoader extends Component<Signature> {
    @service
    session: SemeiaSessionService;
    @service
    requestManager;
    @service
    router: RouterService;
    @service('browser/window')
    window;
    private authenticator = 'authenticator:open-id-connect';
    constructor(owner1: unknown, args1: Signature['Args']){
        super(owner1, args1);
        if (!args1.openIdConnectService) {
            throw 'No openIdConnectService provided';
        }
    }
    get authMethodName() {
        return this.args.openIdConnectService.label;
    }
    // For testing purposes, I need to watch for authorizationCode changes
    callLoginTask = modifier(()=>{
        if (!this.session.medic) {
            this.loginTask.perform();
        }
    });
    loginTask = task(async ()=>{
        try {
            if (!this.args.authorizationCode) {
                const body1 = JSON.stringify({
                    auth: {
                        issuer: this.args.openIdConnectService.issuer
                    }
                });
                const { content: content1 } = await this.requestManager.request({
                    url: '/api/v1/medic_login/sso-login-url',
                    method: 'POST',
                    body: body1
                });
                this.window.location.replace(content1.url);
            } else {
                await this.session.authenticate(this.authenticator, {
                    issuer: this.args.openIdConnectService.issuer,
                    authorizationCode: this.args.authorizationCode
                });
            }
        } catch (error1) {
            const { reason: reason1 } = error1;
            if (reason1) {
                switch(reason1.status){
                    case 401:
                        emberSwal.fire('Oops !', `Impossible de vous connecter via ${this.authMethodName}. Vous n'êtes pas autorisé.`, 'error');
                        break;
                    case 404:
                        emberSwal.fire('Oops !', "Vous n'êtes pas encore enregistré chez Sêmeia. Veuillez contacter nos services pour vous inscrire", 'error');
                        break;
                    default:
                        emberSwal.fire('Oops !', `Impossible de vous connecter via ${this.authMethodName}. Veuillez rééssayer.`, 'error');
                }
                console.error(`${this.authMethodName} error :`, reason1);
                this.router.transitionTo('login');
            } else {
                throw error1;
            }
        }
    });
    static{
        template(`
    <div
      class='ui active loader inline w-full'
      {{this.callLoginTask @authorizationCode}}
    ></div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
